var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _path5, _rect4, _rect5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 63,
    viewBox: "0 0 62 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.0159 41.2918L0 41.2917C6.29699e-06 29.6076 9.20581 20.1387 20.5631 20.1387L41.8019 20.1387L61.0159 20.2076C61.0159 41.2918 61.0159 30.0735 61.0159 41.2918Z",
    fill: "#3388FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0572 42.931C19.4635 45.919 20.2916 48.7688 21.4779 51.4155L42.4852 51.8828C44.4265 51.928 46.3016 51.1605 47.6694 49.7383L58.9201 37.6384C60.2879 36.2162 61.0379 34.2748 60.9938 32.2883L61.0159 2.98717C61.0159 1.83587 60.0673 0.910326 58.9422 0.910326H58.8981H36.5951C34.6538 0.865177 33.5508 1.18122 32.0066 2.55825L20.6676 14.6581C19.2998 16.0577 18.991 17.9991 19.0572 20.0082V42.931Z",
    fill: "#003C8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.8147e-05 40.8955H61.0159C61.0159 52.5796 51.8101 62.0486 40.4528 62.0486H19.214L9.96409 62.0154C4.45528 61.9956 -3.8147e-05 57.5142 -3.8147e-05 52.0053C-3.8147e-05 44.8189 -3.8147e-05 49.5796 -3.8147e-05 40.8955Z",
    fill: "#1760CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.8147e-05 40.9551H61.0159C61.0159 52.6066 51.8101 62.0491 40.4528 62.0491H19.214L9.96419 62.016C4.45535 61.9963 -3.8147e-05 57.5139 -3.8147e-05 52.005C-3.8147e-05 44.8803 -3.8147e-05 49.6033 -3.8147e-05 40.9551Z",
    fill: "#1760CE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.2871,
    y: 31.7827,
    width: 11.9055,
    height: 7.03135,
    rx: 3.51568,
    fill: "#7B4E30"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.1485,
    height: 6.89257,
    rx: 3.44629,
    transform: "matrix(0.49 -0.871723 0.860135 0.510067 15.4768 55.5186)",
    fill: "#7B4E30"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16.7145,
    height: 6.9854,
    rx: 3.4927,
    transform: "matrix(0.860134 0.510067 -0.49 0.871723 22.1736 48.2927)",
    fill: "#7B4E30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8125 34.5635C48.8125 33.3484 48.6259 32.1405 48.2591 30.9821C47.9727 30.0799 47.444 29.2933 46.7169 28.715L44.5165 26.5867L39.2881 57.4635H44.0511C47.0502 52.5756 48.8125 41.5086 48.8125 35.2618V34.5635Z",
    fill: "#AA6C44"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2871,
    y: 44.624,
    width: 12.7985,
    height: 4.27995,
    rx: 2.13998,
    fill: "#7B4E30"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9055,
    y: 41.8721,
    width: 11.9055,
    height: 7.03135,
    rx: 3.51568,
    fill: "#AA6C44"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6465 6.10229H20.3708C18.1617 6.10229 16.3708 7.89315 16.3708 10.1023V52.8503C16.3708 55.0594 18.1617 56.8503 20.3709 56.8503H40.6465C42.8557 56.8503 44.6465 55.0594 44.6465 52.8503V10.1023C44.6465 7.89316 42.8556 6.10229 40.6465 6.10229Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7525 7.93799H19.2627C18.1581 7.93799 17.2627 8.83342 17.2627 9.93799V51.1832C17.2627 52.2878 18.1581 53.1832 19.2627 53.1832H41.7525C42.8571 53.1832 43.7525 52.2878 43.7525 51.1832V9.93799C43.7525 8.83342 42.8571 7.93799 41.7525 7.93799Z",
    fill: "#AFD0FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5107 13.53H23.3076C21.0985 13.53 19.3076 15.3209 19.3076 17.53V43.6631C19.3076 45.8723 21.0985 47.6631 23.3076 47.6631H37.5107C39.7198 47.6631 41.5107 45.8722 41.5107 43.6631V17.53C41.5107 15.3209 39.7198 13.53 37.5107 13.53Z",
    fill: "#EDF4FC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5165 14.8557H22.3018C21.1972 14.8557 20.3018 15.7511 20.3018 16.8557V43.3435C20.3018 44.4481 21.1972 45.3435 22.3018 45.3435H38.5165C39.6211 45.3435 40.5165 44.4481 40.5165 43.3435V16.8557C40.5165 15.7511 39.6211 14.8557 38.5165 14.8557Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1155 22.4775H26.1796C25.8136 22.4775 25.5168 22.7743 25.5168 23.1403C25.5168 23.5064 25.8136 23.8031 26.1796 23.8031H37.1155C37.4815 23.8031 37.7782 23.5064 37.7782 23.1403C37.7782 22.7743 37.4815 22.4775 37.1155 22.4775Z",
    fill: "#7FB5FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.866 23.1403C22.866 23.5064 23.1627 23.8031 23.5287 23.8031C23.8948 23.8031 24.1915 23.5064 24.1915 23.1403C24.1915 22.7743 23.8948 22.4775 23.5287 22.4775C23.1627 22.4775 22.866 22.7743 22.866 23.1403Z",
    fill: "#7FB5FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1155 27.7798H26.1796C25.8136 27.7798 25.5168 28.0765 25.5168 28.4426C25.5168 28.8086 25.8136 29.1053 26.1796 29.1053H37.1155C37.4815 29.1053 37.7782 28.8086 37.7782 28.4426C37.7782 28.0765 37.4815 27.7798 37.1155 27.7798Z",
    fill: "#7FB5FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.866 28.4426C22.866 28.8086 23.1627 29.1053 23.5287 29.1053C23.8948 29.1053 24.1915 28.8086 24.1915 28.4426C24.1915 28.0765 23.8948 27.7798 23.5287 27.7798C23.1627 27.7798 22.866 28.0765 22.866 28.4426Z",
    fill: "#7FB5FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1155 33.4136H26.1796C25.8136 33.4136 25.5168 33.7103 25.5168 34.0764C25.5168 34.4424 25.8136 34.7391 26.1796 34.7391H37.1155C37.4815 34.7391 37.7782 34.4424 37.7782 34.0764C37.7782 33.7103 37.4815 33.4136 37.1155 33.4136Z",
    fill: "#7FB5FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.866 34.0764C22.866 34.4424 23.1627 34.7391 23.5287 34.7391C23.8948 34.7391 24.1915 34.4424 24.1915 34.0764C24.1915 33.7103 23.8948 33.4136 23.5287 33.4136C23.1627 33.4136 22.866 33.7103 22.866 34.0764Z",
    fill: "#7FB5FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8974 39.4783L31.3696 39.6407C30.2848 42.3983 31.9163 45.7215 32.1948 46.2889C32.2223 46.3449 32.2366 46.374 32.2338 46.3732L39.2878 62.0483L35.4185 62.0483L26.4971 46.5121C25.6418 44.9454 25.4617 43.0889 26.049 41.4686C26.2255 41.0598 26.4634 40.6698 26.7669 40.3515C27.8563 39.2631 29.4459 38.9288 30.8974 39.4783Z",
    fill: "#003C8B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8144 60.2305C46.2597 61.3982 43.43 62.0473 40.4524 62.0473H26.479C26.2024 61.503 26.0429 60.939 26.0429 60.3659C26.043 59.0917 25.89 58.666 25.8489 58.5799C25.938 58.7093 26.6598 59.4633 29.6146 57.7673C30.3344 57.3542 30.5765 57.3437 30.7675 57.3354C30.9686 57.3267 31.1131 57.3204 31.6981 56.8502H34.8244L28.7887 45.5995C27.4286 43.225 27.8337 40.3769 29.6879 39.2487C31.5421 38.1204 34.153 39.1514 35.5131 41.5259L42.1357 52.1765C45.3179 53.0265 45.7449 47.9823 46.0081 44.8723L46.0081 44.8723C46.0506 44.3709 46.0888 43.9198 46.1335 43.5518L47.1753 43.0932H47.4729C48.3143 47.3783 49.3639 55.0585 48.8144 60.2305Z",
    fill: "#AA6C44"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.372 61.9576C41.7401 62.0176 41.0998 62.0483 40.4526 62.0483L33.6329 62.0482C36.9069 60.9783 36.1628 59.2969 36.1628 59.2969L28.5673 45.2064C27.3284 43.0474 27.8327 40.376 29.6881 39.2497C30.1918 38.9438 30.7441 38.7842 31.3061 38.7571C30.9023 39.2175 30.6565 39.8271 30.6565 40.4956C30.6565 41.1679 30.9048 41.7807 31.3126 42.242L42.372 61.9576Z",
    fill: "#7B4E30"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskList);
export default __webpack_public_path__ + "static/media/task_list.f6984b43.svg";
export { ForwardRef as ReactComponent };